import { ref } from "vue";
import {
  PainelDeIntegracaoesGateway,
  TChamarServicoParams,
  TChamarServicoResponse
} from "../../../services/PainelDeIntegracaoesGateway";
import { TAPIRules } from "../../../../../@types/IntegracoesAPIRules";
import { EIntegracoesAPIEnum } from "../../../../../@types/IntegracoesAPIEnum";
import { IDefaultHttpFinancasResponse } from "@/core/@types/types";
import { IPluggyConnector } from "@/core/common/Pluggy/services/types";
import {
  normalizeChamarServicoPayload,
  normalizePluggyPayload,
  resolveApiRules,
  resolveChamarServicoUrl,
  supportsSubmitChamarServico
} from "./chamarServicoRequest";

export default function useChamarServico(
  gateway: PainelDeIntegracaoesGateway,
  pluggyConnector?: IPluggyConnector
) {
  const isLoading = ref<boolean>(false);
  const wasTriggered = ref<boolean>(false);

  const handleAPI = (
    apiHash: string,
    apiName?: string
  ): TAPIRules | undefined => {
    return resolveApiRules(apiHash, apiName);
  };

  async function chamarServico(
    params: TChamarServicoParams
  ): Promise<
    IDefaultHttpFinancasResponse<TChamarServicoResponse | boolean> | undefined
  > {
    try {
      isLoading.value = true;

      // Regra de negócio do front-end legado em Global.js: Pluggy possui um
      // fluxo próprio de widget e sincronização, diferente do submit genérico.
      const isPluggy = params.apiHash === EIntegracoesAPIEnum.ApiPluggy;
      const hasSelectedIntegrations = (params.integrations?.length ?? 0) > 0;
      const shouldValidateApiRules =
        !isPluggy && !hasSelectedIntegrations;
      const apiRules = handleAPI(
        params.apiHash?.toString() ?? "",
        params.apiName
      );
      const url = resolveChamarServicoUrl(params, apiRules);

      if (shouldValidateApiRules && !apiRules) {
        return {
          Result: false,
          Error: "API não encontrada",
          Ok: false
        };
      }

      if (shouldValidateApiRules && !supportsSubmitChamarServico(apiRules)) {
        return {
          Result: false,
          Error: "Integração não suporta Buscar novamente",
          Ok: false
        };
      }

      const response = isPluggy
        ? await pluggyConnector?.chamarServico(
            normalizePluggyPayload(params)
          )
        : await gateway.chamarServico(
            normalizeChamarServicoPayload(params, apiRules),
            url ?? ""
          );

      if (response?.Ok) {
        wasTriggered.value = true;
      }

      return response;
    } catch {
      return undefined;
    } finally {
      isLoading.value = false;
    }
  }

  return {
    wasTriggered,
    chamarServico,
    handleAPI
  };
}
